module.exports = __webpack_public_path__ + "8cfe19d20cfa0108d4c01cf358807eee.svg";